import * as Yup from 'yup'
import { IntlShape } from 'react-intl'

import { DOMAIN_NAME_REGEXP } from 'app/consts'
import { commonMessages } from 'app/i18n/messages'

const domainOrJobNameValidator = (formatMessage: IntlShape['formatMessage']) =>
  Yup.string()
    .max(64, formatMessage(commonMessages.renameDomainError))
    .matches(
      DOMAIN_NAME_REGEXP,
      formatMessage(commonMessages.renameDomainError)
    )
    .trim()
    .required(formatMessage(commonMessages.renameDomainError))

export default domainOrJobNameValidator
